export default __webpack_public_path__ + "static/media/flag-macao.9a4a4727.svg";